import React from 'react';
import useTypewriter from '../../hooks/useTypewriter';

const Typewriter = ({ text, speed = 100, delay = 0, className = '', cursorClass = 'animate-pulse' }) => {
    const { displayText, isDone } = useTypewriter(text, speed, delay);

    return (
        <span className={className}>
            {displayText}
            {!isDone && <span className={`${cursorClass} ml-1`}>|</span>}
        </span>
    );
};

export default Typewriter;
